import { render } from "./bills_list.vue?vue&type=template&id=065c481e"
import script from "./bills_list.vue?vue&type=script&lang=js"
export * from "./bills_list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/igor.boldin/projects/edit/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
